import { createAction, props } from '@ngrx/store';
import { AuthUserData } from './models/auth.store';

export const updateToken = createAction(
    '[AUTH] Update Token',
    props<{ tokens: AuthUserData }>(),
);

export const resetToken = createAction('[AUTH] Reset Token');
